import apiHelperFbLive from '@/services/helperFbLive'

const searchPageInshop = async ({ shopId }) => {
    try {
        let url = `/shop/v1/shops/${shopId}/pages/name`
        return (await apiHelperFbLive.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    searchPageInshop
}
